import { createEntityCollectionStore } from '@core/ngrx-legacy';
import type { TalentPool } from '@core/talent-pools-types';

const {
  namespace,
  actions: defaultActions,
  reducer,
  selectors: { byId },
} = createEntityCollectionStore<{
  talentPools: TalentPool[];
  id: string;
}>()('TalentPoolsByCompany');

const actions = {
  fetchOne: defaultActions.fetchOne,
  fetchOneSuccess: defaultActions.fetchOneSuccess,
  fetchOneFailed: defaultActions.fetchOneFailed,
};

const TalentPoolsByCompanySelectors = { byId };

export {
  actions as TalentPoolsByCompanyActions,
  reducer as TalentPoolsByCompanyReducer,
  TalentPoolsByCompanySelectors,
  namespace as TalentPoolsByCompanyNamespace,
};
